import type { ReactElement, SVGProps } from "react";

export function UserSilhouetteFilledIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M8 8a3 3 0 100-6 3 3 0 000 6zM2 14s0-4 6-4 6 4 6 4H2z" />
    </svg>
  );
}
